import { useEffect } from 'react';
import type { FieldErrors, FieldValues } from 'react-hook-form';
import { isEmpty } from 'lodash-es';

interface UseScrollToErrorOptions<
  TFieldValues extends FieldValues = FieldValues,
> {
  errors: FieldErrors<TFieldValues>;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
}

const useScrollToError = <TFieldValues extends FieldValues = FieldValues>
({
   errors,
   behavior = 'smooth',
   block = 'center',
 }: UseScrollToErrorOptions<TFieldValues>): void => {
  useEffect(() => {
    if (isEmpty(errors)) return;

    const errorKeys = Object.keys(errors) as (keyof TFieldValues)[];
    const firstErrorField = errorKeys[0];
    if (!firstErrorField) return;

    const element = document.querySelector<HTMLElement>(
      `[name="${String(firstErrorField)}"]`,
    );
    if (!element) return;

    element.scrollIntoView({
      behavior,
      block,
    });
  }, [errors, behavior, block]);
};

export default useScrollToError;
